import {EventEmitter} from '@angular/core';

export class GlobalState {
    public mainMenuChanged = new EventEmitter();
    public mainMenuHide = new EventEmitter();
    public onToggleOverlay = new EventEmitter();

    public changeMenuHide() {
        this.mainMenuChanged.emit();
    }

    public changeMainMenu() {
        this.mainMenuChanged.emit();
    }


    public toggleOverlay() {
        this.onToggleOverlay.emit();
    }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/global.state.ts